<template>
  <div class="function-detail-page">
    <!-- 顶部简易导航 -->
    <header class="detail-header">
      <div class="detail-header-inner">
        <div class="logo-area">
          <img src="@/assets/logo/logo.png" class="logo-img" alt="logo" />
          <span class="logo-text">小虫单管理系统 · 产品功能</span>
        </div>
        <div class="header-actions">
          <el-button type="text" @click="$router.push('/homepage')">返回官网首页</el-button>
        </div>
      </div>
    </header>

    <!-- 主体内容 -->
    <main class="detail-main">
      <section class="system-selector">
        <div class="selector-label">产品功能：</div>
        <div class="selector-list">
          <div
            v-for="item in systems"
            :key="item.key"
            :class="['selector-item', { active: currentKey === item.key }]"
            @click="switchSystem(item.key)"
          >
            {{ item.name }}
          </div>
        </div>
      </section>

      <section v-if="currentSystem" class="system-detail">
        <h1 class="system-title">{{ currentSystem.name }}</h1>

        <div
          v-for="(card, index) in currentSystem.cards"
          :key="index"
          class="detail-card"
        >
          <div class="detail-card-title">{{ card.title }}</div>
          <div class="detail-card-content">{{ card.content }}</div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ProductFunctionDetail',
  data() {
    return {
      currentKey: this.$route.query.type || 'order',
      systems: [
        {
          key: 'order',
          name: '工单系统',
          cards: [
            {
              title: '工单填写',
              content: '轻松填单，秒懂上手。字段标准化配置，一线员工按提示即可完成工单录入，降低培训成本。'
            },
            {
              title: '方案单',
              content: '一键生成任务方案，服务执行更清晰。支持标准方案与个性化方案，覆盖不同业态需求。'
            },
            {
              title: '转单审批',
              content: '一键转交，流程在线可溯。支持上报、转单、协作多种场景，保证信息不丢失。'
            },
            {
              title: '工单查询',
              content: '随时追踪工单进度，完整记录有据可查，让管理者对项目状态一目了然。'
            }
          ]
        },
        {
          key: 'management',
          name: '管理系统',
          cards: [
            {
              title: '客户管理',
              content: '告别纸质建档，手机端即可查看客户信息与历史记录。精细洞察需求，打造贴心服务体验。'
            },
            {
              title: '员工管理',
              content: '构建员工数字档案，位置信息与工单执行实时可见，为排班与绩效评估提供数据支持。'
            }
          ]
        },
        {
          key: 'schedule',
          name: '排班系统',
          cards: [
            {
              title: '人工排班',
              content: '一键导入排班文件，系统自动生成排班表，满足临时调整、常规排班等不同场景。'
            },
            {
              title: 'AI排班',
              content: '导入任务数据，AI 自动规划最优路线与时间段，自动作出高效排班方案，让管理更省心。'
            }
          ]
        },
        {
          key: 'report',
          name: '服务报告',
          cards: [
            {
              title: 'AI服务报告',
              content: '服务完成后，AI 将现场勘查与服务数据自动生成图文报告，“秒发”给客户，专业、规范又省时。'
            }
          ]
        },
        {
          key: 'analysis',
          name: '数据统计分析',
          cards: [
            {
              title: '量化运营数据',
              content: '量化员工工效，完整呈现工单完成率、工时与频次变化，帮助管理者看清运营情况。'
            },
            {
              title: '多维度统计',
              content: '支持按客户、项目、服务类型等维度进行分析，识别业务结构和增长机会，为决策提供依据。'
            }
          ]
        },
        {
          key: 'mobile',
          name: '移动管理',
          cards: [
            {
              title: '移动办公',
              content: '移动端 APP 打通从接单、执行、回执到报告的全流程，随时随地管理工单与团队。'
            }
          ]
        }
      ]
    }
  },
  computed: {
    currentSystem() {
      return this.systems.find(s => s.key === this.currentKey) || this.systems[0]
    }
  },
  watch: {
    '$route.query.type'(val) {
      if (val) {
        this.currentKey = val
      }
    }
  },
  methods: {
    switchSystem(key) {
      this.currentKey = key
      this.$router.replace({
        path: '/homepage/function',
        query: { type: key }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.function-detail-page {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.detail-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.detail-header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;

  .logo-img {
    width: 32px;
    height: 32px;
  }

  .logo-text {
    font-size: 16px;
    font-weight: 600;
    color: #1b5898;
  }
}

.detail-main {
  max-width: 1000px;
  margin: 24px auto 40px;
  padding: 0 16px 40px;
}

.system-selector {
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  .selector-label {
    font-weight: 600;
    margin-right: 12px;
  }

  .selector-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .selector-item {
    min-width: 90px;
    text-align: center;
    padding: 6px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    background: #ffffff;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #1b5898;
      color: #1b5898;
    }

    &.active {
      background: #1b5898;
      color: #ffffff;
      border-color: #1b5898;
    }
  }
}

.system-detail {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 32px 32px 40px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
  animation: fadeInUp 0.4s ease;
}

.system-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
}

.detail-card {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
  background: #ffffff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }
}

.detail-card-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.detail-card-content {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .system-detail {
    padding: 24px 16px 32px;
  }
}
</style>



